import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-6 col-5 text-right" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ni ni-time-alarm mr-0" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-none d-lg-inline ml-1" }, "Tiempo de pausa")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chart-bar mr-0" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-none d-lg-inline ml-1" }, "Estadistica")
], -1)

export interface Irow {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	row: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rowIndex: any;
}
import Table from "@/components/Table.vue";

import { IndicatorsModule } from "@/store/modules/Indicators";

import { ref, computed } from "vue";
import { ElDialog } from "element-plus";
import PinPhone from "@/callcenter/components/PinPhone.vue";
import { env } from "@/config/index";
import { AuthModule } from "@/store/modules/Auth";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const callEnv = env.requiredCallcenter;
const fullAuth = computed(() => AuthModule.FullAuth);

const indicatorStatus = computed(() => {
	return IndicatorsModule.IndicatorStatus;
});
const indicator = computed(() => {
	return IndicatorsModule.Indicators ? IndicatorsModule.Indicators : {};
});

/* const lunchCallHistory = () => {
	model.value.modal = true;

	IndicatorsModule.updateCallHistory();
}; */
const lunchPauseHistory = () => {
	model.value.modal = true;
	IndicatorsModule.updatePauseHistory();
};
const lunchAgentStatistics = () => {
	model.value.modal = true;

	IndicatorsModule.updateStatistics();
};
const loading = computed(() => {
	return IndicatorsModule.Loading;
});
const pagination = {
	perPage: 6,
	currentPage: 1,
	perPageOptions: [6, 10, 25, 50],
	total: 0,
};
/* const total = computed(() => {
	return indicator.value?.td.length;
}); */

/* const from = computed(() => {
	return (
		model.value.pagination.perPage * (model.value.pagination.currentPage - 1)
	);
}); */

/* const to = computed(() => {
	let highBound = from.value + model.value.pagination.perPage;
	if ((total.value as number) < highBound) {
		highBound = total.value as number;
	}
	return highBound;
}); */

/* const pagedData = computed(() => {
	return indicator.value?.td?.slice(from.value, to.value);
});

const tableRowClassName = (rows: Irow) => {
	if (indicatorStatus.value === IindicatorStatus.PauseHistory) {
		if (rows.row.tiempo_pausa > rows.row.tiempo_total) {
			return "danger-row";
		}
	}

	return "";
}; */
const model = ref({
	modal: false,
	pagination,
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_tooltip, { content: "Consultar tiempo de pausa" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            size: "sm",
            type: "warning",
            onClickCapture: lunchPauseHistory
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_tooltip, { content: "Consultar estadisticas" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            size: "sm",
            type: "primary",
            onClickCapture: lunchAgentStatistics
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(callEnv) && _unref(fullAuth))
        ? (_openBlock(), _createBlock(PinPhone, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(ElDialog), {
      modelValue: model.value.modal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.modal) = $event)),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(Table, {
            "card-class": "m--6 shadow-none rounded",
            tableData: _unref(indicator),
            tittle: _unref(indicatorStatus),
            load: _unref(loading)
          }, null, 8, ["tableData", "tittle", "load"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})